import React from "react";
import { Container, Typography, Box, Paper, Divider } from "@mui/material";

export default function CookiePolicy() {
  return (
    <Box sx={{ py: 8, bgcolor: "#f5f7fa" }}>
      <Container maxWidth="md">
        <Paper elevation={2} sx={{ p: { xs: 4, md: 6 }, borderRadius: 3 }}>
          <Typography variant="h3" fontWeight={700} color="primary" gutterBottom>
            Cookie Policy
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" paragraph>
            Last Updated: {new Date().toLocaleDateString()}
          </Typography>
          <Divider sx={{ mb: 4 }} />

          <Typography variant="h5" fontWeight={600} gutterBottom sx={{ mt: 4 }}>
            Collection of non-personal information
          </Typography>
          <Typography variant="body1" paragraph>
            We automatically track certain information about you based upon your behaviour on our Platform. We use this information to do internal research on our users’ demographics, interests, and behaviour to better understand, protect and serve our users and improve our services. This information is compiled and analysed on an aggregated basis. We also collect your Internet Protocol (IP) address and the URL used by you to connect your computer to the internet, etc. This information may include the URL that you just came from (whether this URL is on our Website or not), which URL you next go to (whether this URL is on our Website or not), your computer browser information, and your IP address.
          </Typography>

          <Typography variant="h5" fontWeight={600} gutterBottom sx={{ mt: 4 }}>
            How We Use Cookies
          </Typography>
          <Typography variant="body1" paragraph>
            Cookies are small data files that a Website stores on Your computer. We will use cookies on our Website similar to other lending websites/apps and online marketplace websites/apps. Use of this information helps Us identify You in order to make our Website more user friendly. Most browsers will permit You to decline cookies but if You choose to do this it might affect service on some parts of Our Website. If you choose to make a purchase through the Platform, we collect information about your buying behaviour. We retain this information as necessary to resolve disputes, provide customer support and troubleshoot problems as permitted by law.
          </Typography>

          <Typography variant="h5" fontWeight={600} gutterBottom sx={{ mt: 4 }}>
            Contact Us
          </Typography>
          <Typography variant="body1" paragraph>
            If you send us personal correspondence, such as emails or letters, or if other users or third parties send us correspondence about your activities or postings on the Website, we collect such information into a file specific to you. For inquiries, email support@riteaccount.com.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}
